import BpkLargeAdultIcon from '@skyscanner/backpack-web/bpk-component-icon/lg/adult';
import BpkInput from '@skyscanner/backpack-web/bpk-component-input';
import BpkModal from '@skyscanner/backpack-web/bpk-component-modal';
import BpkText, {
  TEXT_STYLES,
} from '@skyscanner/backpack-web/bpk-component-text';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import GuestsRoomsChildren from '../GuestsRoomsChildren';

import type { I18nService } from '@shared/types/i18n';
import type { Maybe } from '@shared/types/utils';
import type { ModalClose } from '@shared/ui//types';

import STYLES from './GuestsRoomsChildrenPortal.module.scss';

import { HASH_GUESTS_ROOMS_CHILDREN } from '@shared/constants/hash-routes';
import HashRoute from '@shared/ui/common/HashRoute';
import RouteLink from '@shared/ui/common/RouteLink';
import { withI18n } from '@shared/ui/contexts/i18n';
import { getApplicationElement } from '@shared/utils-frontend/ApplicationElements';
import getGuestsRoomsChildrenValue from '@shared/utils-frontend/getGuestsRoomsChildrenValue';

const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  adults: number;
  rooms: number;
  childrenAges: number[];
  className?: Maybe<string>;
  guestsRoomsFieldId: string;
  isApplyButtonDisabled?: boolean;
  onlyShowGuestsNumber?: boolean;
  onOpen: Function;
  onClose: (shouldUpdate: boolean) => void;
  onGuestsRoomsChildrenChanged: (
    rooms: number,
    adults: number,
    childrenAges: number[],
  ) => void;
};

const GuestsRoomsChildrenPortal = ({
  adults,
  childrenAges,
  className,
  guestsRoomsFieldId,
  i18n,
  isApplyButtonDisabled,
  onClose: onApply,
  onGuestsRoomsChildrenChanged,
  onOpen,
  onlyShowGuestsNumber,
  rooms,
}: Props) => (
  <div className={cls('GuestsRoomsChildrenPortal', className)}>
    <RouteLink
      shouldGoBack={false}
      href={HASH_GUESTS_ROOMS_CHILDREN}
      onClick={onOpen}
      render={(onClickLink: any) => (
        <div
          role="button"
          tabIndex={0}
          onKeyUp={() => {}}
          onClick={onClickLink}
          className={cls(
            onlyShowGuestsNumber && 'GuestsRoomsChildrenPortal__input',
          )}
          data-test-id={guestsRoomsFieldId}
          data-testid={guestsRoomsFieldId}
          aria-label={i18n.translate('HotelStay_label_guests_rooms')}
        >
          {onlyShowGuestsNumber ? (
            <div className={cls('GuestsRoomsChildrenPortal__guestInfo')}>
              <BpkLargeAdultIcon
                className={cls('GuestsRoomsChildrenPortal__icon')}
              />
              <BpkText
                textStyle={TEXT_STYLES.caption}
                className={cls('GuestsRoomsChildrenPortal__guestText')}
              >
                {adults + (childrenAges ? childrenAges.length : 0)}
              </BpkText>
            </div>
          ) : (
            <BpkInput
              id="guests-rooms-children-portal"
              name="guests-rooms-children-portal"
              readOnly
              value={getGuestsRoomsChildrenValue({
                adults,
                rooms,
                childrenAges,
                translatePlural: i18n.translatePlural,
              })}
            />
          )}
        </div>
      )}
    />
    <HashRoute
      hash={HASH_GUESTS_ROOMS_CHILDREN}
      render={({ onClose }: { onClose: ModalClose }) => (
        <BpkModal
          isOpen
          closeLabel={i18n.translate('Modal_close')}
          onClose={onClose}
          getApplicationElement={getApplicationElement}
          padded={false}
          title={i18n.translate('HotelStay_label_guests_rooms')}
          id="explore label dates"
        >
          <GuestsRoomsChildren
            adults={adults}
            rooms={rooms}
            childrenAges={childrenAges}
            onGuestsRoomsChildrenChanged={onGuestsRoomsChildrenChanged}
            hasFooter
            onApply={onApply}
            onClose={onClose}
            isApplyButtonDisabled={isApplyButtonDisabled}
          />
        </BpkModal>
      )}
    />
  </div>
);

export default withI18n(GuestsRoomsChildrenPortal);
